import {
  isNexusDemoDonePrompt,
  threadAwaitingNexusDemoDnsDone,
} from '@/features/chat/demo/isNexusDemoDonePrompt.js'
import { isGcpHostingDemoPrompt } from '@/features/chat/demo/isGcpHostingDemoPrompt'
import { isWebsiteCrmDemoPrompt } from '@/features/chat/demo/isWebsiteCrmDemoPrompt'
import {
  isWebsiteCrmProceedPrompt,
  threadAwaitingWebsiteCrmDeployProceed,
} from '@/features/chat/demo/isWebsiteCrmProceedPrompt.js'
import { isZohoCrmIntegrationDemoPrompt } from '@/features/chat/demo/isZohoCrmIntegrationDemoPrompt'
import { isB2bCopilotPlanDemoPrompt } from '@/features/chat/demo/isB2bCopilotPlanDemoPrompt'
import {
  isDesignDnaFigmaPublishPrompt,
  threadAwaitingDesignDnaFigmaPublish,
} from '@/features/chat/demo/isDesignDnaFigmaPublishPrompt.js'
import { runNexusDemoJourneySummaryStream } from './runNexusDemoJourneySummaryStream.js'
import { runWebsiteCrmProceedTurn } from './runWebsiteCrmProceedTurn.js'
import { runGcpHostingDemoStream } from './runGcpHostingDemoStream.js'
import { runWebsiteCrmDemoStream } from './runWebsiteCrmDemoStream.js'
import { runZohoCrmIntegrationDemoStream } from './runZohoCrmIntegrationDemoStream.js'
import { runB2bCopilotPlanDemoStream } from './runB2bCopilotPlanDemoStream.js'
import { runDesignDnaFigmaPublishDemoStream } from './runDesignDnaFigmaPublishDemoStream.js'

/** Each entry: when({ trimmed, priorMessages, files, ... }) → run(ctx). */
export const DEMO_MATCHERS_PART01 = [
  {
    when: (q) => isNexusDemoDonePrompt(q.trimmed) && threadAwaitingNexusDemoDnsDone(q.priorMessages),
    run: runNexusDemoJourneySummaryStream,
  },
  {
    when: (q) =>
      isWebsiteCrmProceedPrompt(q.trimmed) && threadAwaitingWebsiteCrmDeployProceed(q.priorMessages),
    run: runWebsiteCrmProceedTurn,
  },
  { when: (q) => isGcpHostingDemoPrompt(q.trimmed), run: runGcpHostingDemoStream },
  { when: (q) => isWebsiteCrmDemoPrompt(q.trimmed), run: runWebsiteCrmDemoStream },
  { when: (q) => isZohoCrmIntegrationDemoPrompt(q.trimmed), run: runZohoCrmIntegrationDemoStream },
  { when: (q) => isB2bCopilotPlanDemoPrompt(q.trimmed), run: runB2bCopilotPlanDemoStream },
  {
    when: (q) =>
      isDesignDnaFigmaPublishPrompt(q.trimmed) && threadAwaitingDesignDnaFigmaPublish(q.priorMessages),
    run: runDesignDnaFigmaPublishDemoStream,
  },
]
